// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-page {
    background: white;
}


.nav-container {
    display: flex;
    flex-direction: row;
    justify-content: right;
    gap: 4rem;
}

.nav-box {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.app-nav-link {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100px;
}

.app-nav-link img {
    width: 55px;
}

.app-nav-link img:hover {
    box-shadow: 2px 2px black;
    border-radius: 7px;
}

.navtitle {
    margin-top: 5px;
    font-size: 9pt;
    font-weight: lighter;
    text-align: center;
}

.appContainer {
    padding: 10px 20px;
}

.appContainer div {
    margin-bottom: 5px;
    overflow-wrap: break-word;
    line-height: 1.7;
}

.subtitle {
    font-size: 18pt;
    font-weight: 200;
    margin-bottom: 10px;
}

.appSteps img {
    margin-right: 10px;
}

.bullet {
    margin-top: 10px;
}

.bullet span {
    vertical-align: top;
    font-size: 21px;
    font-weight: 900;
    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
}

.nbb .bullet span {
    color: #fd345d;
}

.pb .bullet span {
    color: #ffc91d;
}

.efs .bullet span {
    color: #7c82a0;
}

.ets .bullet span {
    color: #005694;
}

.mtt .bullet span {
    color: #8db3ab;
}

.mtr .bullet span {
    color: #b0d55d;
}

.store-play {
    display: flex;
    flex-direction: row;
}

.store-link img {
    width: 100px;
    margin-top: 10px;
    padding-right: 5px;
}

@media screen and (max-width: 1081px) {
    .bigImg img {
        max-width: 500px;
    }
}

@media screen and (max-width: 786px) {
    .navtitle {
        margin-top: 2px;
        font-size: 6pt;
    }

    .app-nav-link {
        width: 50px;
    }

    .app-nav-link img {
        width: 35px;
    }

    .nav-container {
        gap: 1rem;
    }

    .app-nav-link {
        width: 50px;
    }

    .app-nav-link img {
        width: 35px;
    }

    .navtitle {
        font-size: 4pt;
    }

    .bigImg img {
        max-width: 300px;
    }
}

@media screen and (max-width: 357px) {
    .navtitle {
        font-size: 5pt;
    }

    .app-nav-link {
        width: 40px;
    }

    .app-nav-link img {
        width: 25px;
    }

    .app-nav-link {
        width: 40px;
    }

    .app-nav-link img {
        width: 25px;
    }

    .navtitle {
        font-size: 3pt;
    }

    .bigImg img {
        max-width: 200px;
    }

    .store-link img {
        width: 80px;
    }
}

@media screen and (max-width: 311px) {
    .app-nav-link {
        width: 35px;
    }

    .app-nav-link img {
        width: 20px;
    }

    .app-nav-link {
        width: 30px;
    }

    .app-nav-link img {
        width: 20px;
    }

    .store-link img {
        width: 60px;
    }

    .navtitle {
        font-size: 2pt;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/app.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,8IAA8I;AAClJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".app-page {\n    background: white;\n}\n\n\n.nav-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: right;\n    gap: 4rem;\n}\n\n.nav-box {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.app-nav-link {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100px;\n}\n\n.app-nav-link img {\n    width: 55px;\n}\n\n.app-nav-link img:hover {\n    box-shadow: 2px 2px black;\n    border-radius: 7px;\n}\n\n.navtitle {\n    margin-top: 5px;\n    font-size: 9pt;\n    font-weight: lighter;\n    text-align: center;\n}\n\n.appContainer {\n    padding: 10px 20px;\n}\n\n.appContainer div {\n    margin-bottom: 5px;\n    overflow-wrap: break-word;\n    line-height: 1.7;\n}\n\n.subtitle {\n    font-size: 18pt;\n    font-weight: 200;\n    margin-bottom: 10px;\n}\n\n.appSteps img {\n    margin-right: 10px;\n}\n\n.bullet {\n    margin-top: 10px;\n}\n\n.bullet span {\n    vertical-align: top;\n    font-size: 21px;\n    font-weight: 900;\n    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;\n}\n\n.nbb .bullet span {\n    color: #fd345d;\n}\n\n.pb .bullet span {\n    color: #ffc91d;\n}\n\n.efs .bullet span {\n    color: #7c82a0;\n}\n\n.ets .bullet span {\n    color: #005694;\n}\n\n.mtt .bullet span {\n    color: #8db3ab;\n}\n\n.mtr .bullet span {\n    color: #b0d55d;\n}\n\n.store-play {\n    display: flex;\n    flex-direction: row;\n}\n\n.store-link img {\n    width: 100px;\n    margin-top: 10px;\n    padding-right: 5px;\n}\n\n@media screen and (max-width: 1081px) {\n    .bigImg img {\n        max-width: 500px;\n    }\n}\n\n@media screen and (max-width: 786px) {\n    .navtitle {\n        margin-top: 2px;\n        font-size: 6pt;\n    }\n\n    .app-nav-link {\n        width: 50px;\n    }\n\n    .app-nav-link img {\n        width: 35px;\n    }\n\n    .nav-container {\n        gap: 1rem;\n    }\n\n    .app-nav-link {\n        width: 50px;\n    }\n\n    .app-nav-link img {\n        width: 35px;\n    }\n\n    .navtitle {\n        font-size: 4pt;\n    }\n\n    .bigImg img {\n        max-width: 300px;\n    }\n}\n\n@media screen and (max-width: 357px) {\n    .navtitle {\n        font-size: 5pt;\n    }\n\n    .app-nav-link {\n        width: 40px;\n    }\n\n    .app-nav-link img {\n        width: 25px;\n    }\n\n    .app-nav-link {\n        width: 40px;\n    }\n\n    .app-nav-link img {\n        width: 25px;\n    }\n\n    .navtitle {\n        font-size: 3pt;\n    }\n\n    .bigImg img {\n        max-width: 200px;\n    }\n\n    .store-link img {\n        width: 80px;\n    }\n}\n\n@media screen and (max-width: 311px) {\n    .app-nav-link {\n        width: 35px;\n    }\n\n    .app-nav-link img {\n        width: 20px;\n    }\n\n    .app-nav-link {\n        width: 30px;\n    }\n\n    .app-nav-link img {\n        width: 20px;\n    }\n\n    .store-link img {\n        width: 60px;\n    }\n\n    .navtitle {\n        font-size: 2pt;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
